import { hero } from '@/content/site'

import { BrandkitCanvas } from './hero/BrandkitCanvas'
import { SplitTitle } from './shared/SplitTitle'

export function Hero() {
  return (
    <section className="relative pt-32 sm:pt-40 md:pt-48 pb-16 md:pb-24">
      <div className="shell relative">
        {/* Centred rather than side-by-side: the assembled kit below is the
            widest thing on the page and reads better full-bleed. */}
        <div className="mx-auto max-w-3xl text-center">
          <p className="eyebrow">{hero.eyebrow}</p>

          <h1 className="font-sans text-[2rem] sm:text-[2.75rem] md:text-[3.5rem] font-semibold tracking-[-0.03em] leading-[1.06] text-ink">
            <SplitTitle text={hero.title} />
          </h1>

          <p className="mx-auto mt-6 max-w-2xl font-paragraph text-[0.98rem] md:text-[1.08rem] leading-[1.7] text-ink-dim">
            {hero.subtitle}
          </p>

          <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
            <a href={hero.primaryCta.href} className="btn btn-primary focus-ring">
              {hero.primaryCta.label}
            </a>
            <a href={hero.ghostCta.href} className="btn btn-glass focus-ring">
              {hero.ghostCta.label}
            </a>
          </div>
        </div>

        <div className="mt-14 md:mt-20">
          <BrandkitCanvas />
          <p className="micro mt-4 text-center">{hero.canvasCaption}</p>
        </div>
      </div>
    </section>
  )
}
